module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/suffix.js
// module id = 1359
// module chunks = 0